import { CURRENT_REGION } from './config';
import { Regions } from './types';

const IS_EU = CURRENT_REGION === Regions.EU;
export const IS_UK = CURRENT_REGION === Regions.UK;
const IS_TR = CURRENT_REGION === Regions.TR;
export const IS_SG = CURRENT_REGION === Regions.SG;

export const HEADER_CURRENCY_ENABLED = !IS_EU;
export const DATEV_ACCOUNTANT_SYSTEM_ENABLED = IS_EU;
export const VAT_EXEMPT_ENABLED = IS_TR || IS_UK;
export const VAT_EXEMPT_CERTIFICATES_ENABLED = IS_EU;
export const PEPPOL_BILLING_ENABLED = IS_EU;
/**
 * In the EU we used to have logic that all EU Billing accounts should have VAT BA. And Foreign Billing Accounts are having TAX_ID. The difference is that the second is not a subject of our validation.
 * In the UK, to keep the same structure, we need to change how we determine who is “Foreign”
 * https://xometry.atlassian.net/browse/XEUK-414
 */
export const SHIPMENT_ORDER_ENABLED = IS_EU || IS_UK || IS_TR || IS_SG;
export const MS_SHIPMENT_ORDER_ENABLED = IS_EU || IS_UK || IS_TR;
export const SHIPMENT_AUTO_ORDER_ENABLED = IS_EU;
export const ENQUIRIES_CUSTOM_VAT_ENABLED = IS_TR;
export const TEMP_CONTENT_FORM_NO_CURRENCY = IS_TR;
export const TEMP_CONTENT_FORM_DISABLED_CASE_LINK_RULES = IS_TR;
export const II_POSITIONS_NEED_CURRENCY = IS_TR || IS_UK;
export const CAN_EDIT_CURRENCY = IS_TR;
export const WITH_PREFERRED_LANGUAGE = IS_TR;
export const SUPPLIERS_WITH_MANUAL_VALUE = IS_TR;
export const CAN_CREATE_BP_IN_II = IS_EU;
export const CAN_CREATE_BP_IN_PZ = IS_EU;
export const RETURN_INVOICE_INSTEAD_OF_CREDIT_NOTE = IS_TR;
export const IS_CURRENCY_CHANGE_PROHIBITED_IN_PO = IS_EU || IS_UK;
export const DDP_SHIPPING_BASIS_ENABLED = IS_UK;
export const EXW_SHIPPING_BASIS_ENABLED = IS_TR;
export const DATEV_COMMENT_SHOW = IS_EU;
export const SENDING_SMS_VAKIFBANK_ENABLED = IS_TR;
/** https://xometry.atlassian.net/browse/XEFIN-229 */
export const NOT_VAT_PAYER_ENABLED = IS_EU;
/** https://xometry.atlassian.net/browse/EUO-414 */
export const PROVIDER_NOT_VAT_PAYER_ENABLED = IS_EU || IS_TR;
export const TAGS_MAPPING_RFQ_ONLY = IS_EU;
export const PART_RESTART_WORKFLOW_ENABLED = IS_EU;
export const BULK_ACTIONS_PART_RESTART_WORKFLOW_ENABLED = IS_UK;

// DATEV VS INTACCT
export const DATEV_ENABLED = IS_EU;
export const INTACCT_ENABLED = IS_UK || IS_TR || IS_SG;
export const CUSTOM_IO_NAME_ENABLED = IS_TR;

export const BANK_CODE_REQUIRED = !IS_TR;

export const XOMETRY_VAT_ENABLED = IS_EU || IS_UK;
export const SACHKONTO_VAT_RATE_VALIDATION_ENABLED = IS_EU;

export const HAVE_INVOICE_BATCH_EXPORTS = IS_EU;
export const HAS_ACCOUNTING_NAME = IS_EU || IS_UK || IS_SG;
export const HAS_INTACCT_ENABLED = IS_UK || IS_SG;
export const OI_PUBLISH_SEND_TO_INTACCT_POPUP_ENABLED = IS_UK;
/** https://xometry.atlassian.net/browse/EUO-583 */
export const II_PUBLISH_SEND_TO_INTACCT_POPUP_ENABLED = IS_UK;
/** https://xometry.atlassian.net/browse/EUO-458 */
export const INTACCT_PAYMENTS_SYNC_UI_ENABLED = IS_UK;
export const TAX_ID_IS_MAIN_TAX_FIELD = IS_TR || IS_UK || IS_SG;
export const VAT_VALIDATION_ENABLED = IS_EU;
export const VAT_VALIDATION_FLOW_ENABLED = IS_EU;
/** https://xometry.atlassian.net/browse/EUO-371, EUO-500 */
export const SELF_BILLING_ENABLED = IS_EU || IS_UK || IS_SG || IS_TR;
export const MICROJUMP_ENABLED = IS_TR;
export const REJECT_OI_ENABLED = IS_TR;
export const PRIVATE_PERSON_TAX_ID_ENABLED = IS_TR;

/** https://xometry.atlassian.net/browse/XETW-1300 */
export const SHOW_ORIGINAL_SHIPPING_OPTION_PRICE = !IS_EU;

/** https://xometry.atlassian.net/browse/XETW-1931 */
export const SHIPPING_COST_CURRENCY_CHANGER_ENABLED = IS_TR || IS_UK;

/** https://xometry.atlassian.net/browse/XEFIN-2037 */
export const ACCRUAL_INVOICE_ENABLED = IS_TR;
export const II_PRE_VALIDATION_ENABLED = IS_EU;

/** Non-part position default names: English only when adding on OI, OC, II (e.g., SG) */
export const POSITION_NAMES_ENGLISH_ONLY = IS_SG;

/** https://xometry.atlassian.net/browse/XETW-2538 */
export const SHIPPING_DOCUMENTS_LOCALIZATION_ENABLED = IS_EU;

/** https://xometry.atlassian.net/browse/XETW-2369 */
export const SHIPPING_GERLACH_UPLOADING_ENABLED = IS_EU;

/** https://xometry.atlassian.net/browse/EUO-480 */
export const PREPAYMENT_WRITE_OFF_ENABLED = IS_EU;

/** https://xometry.atlassian.net/browse/EUO-609 */
export const II_ZERO_VAT_RATE_ENABLED = IS_SG;
/** https://xometry.atlassian.net/browse/EUO-389, EUO-390 */
export const BILLING_PREFERENCE_ENABLED = IS_SG || IS_TR;
/** https://xometry.atlassian.net/browse/EUO-734 */
export const CUSTOMER_DELIVERY_SEND_TO_EXTERNAL_ENABLED = false;
/** SG orders third-party customer deliveries in OMS, so Send to External is hidden for all of its shippings (incl. X2C) */
export const SEND_TO_EXTERNAL_ENABLED = !IS_SG;
/** TR and SG fetch and order third-party FedEx customer deliveries (P2C, X2C) in OMS instead of sending them to external */
export const CUSTOMER_DELIVERY_FEDEX_FETCH_OPTIONS_ENABLED = IS_SG || IS_TR;
